/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Namespaces } from '../../../../i18n';
import { SUDatasetCategory } from '../../../../types/superuser/dataset-category/SUDatasetCategory';
import { SUDatasetCategoryI18n } from '../../../../types/superuser/dataset-category/SUDatasetCategoryI18n';
import { useDatasetsCategoriesDetailPanelStyles } from './DatasetsCategoriesDetailPanel.styles';

type DatasetsCategoriesDetailPanelProps = {
  rowData: SUDatasetCategory;
  prepareDate: (date: string) => string;
};

export function DatasetsCategoriesDetailPanel(props: DatasetsCategoriesDetailPanelProps) {
  const classes = useDatasetsCategoriesDetailPanelStyles();
  const { t } = useTranslation(Namespaces.Admin);
  const { rowData, prepareDate } = props;

  return (
    <div className={classes.detailPanelRoot}>
      {rowData.i18n.map((i18n: SUDatasetCategoryI18n, key) => (
        <div className={classes.blockInfo} key={key}>
          <b>
            {t('datasets.categories.table.labels.name', {
              currentLanguage: i18n.language.toUpperCase(),
            })}
          </b>
          :<span>{i18n.title}</span>
        </div>
      ))}
      <div className={classes.blockInfo}>
        <b>{t('datasets.categories.table.labels.identifier')}</b>:<span>{rowData.identifier}</span>
      </div>
      <div className={classes.blockInfo}>
        <b>{t('datasets.categories.table.labels.created_at')}</b>:<span>{prepareDate(rowData.createdAt)}</span>
      </div>
      <div className={classes.blockInfo}>
        <b>{t('datasets.categories.table.labels.updated_at')}</b>:<span>{prepareDate(rowData.updatedAt)}</span>
      </div>
      <div className={classes.blockInfo}>
        <b>{t('datasets.categories.table.labels.datasets')}</b>:<span>{rowData.datasets || 0}</span>
      </div>
    </div>
  );
}
